// Single source of truth for the marketing site's brand name. The company's
// legal name is "Resilience Damages"; in marketing it's referred to as
// "Resilience" (client direction). Change BRAND and the whole site updates.
export const BRAND = 'Resilience'

// Primary contact address used across the footer + Enterprise CTA.
export const CONTACT_EMAIL = 'info@resiliencedamages.com'

export type PlanFeature = { t: string; soon?: boolean }
export type Plan = {
  name: string
  price: string
  period: string
  note: string
  blurb: string
  cta: string
  ctaHref: string
  featured: boolean
  features: PlanFeature[]
}

// Pricing confirmed with the client (2026-09). Free is forever (no trial/card),
// Grow is the featured tier, Enterprise is a starting price or custom quote.
// Features tagged `soon` are on the roadmap, not yet live in the app.
export const PLANS: Plan[] = [
  {
    name: 'Forever Free',
    price: '$0',
    period: 'forever',
    note: 'No trial, no credit card',
    blurb: 'Everything a single crew needs to document damage and close cases.',
    cta: 'Get Started Free',
    ctaHref: '/register',
    featured: false,
    features: [
      { t: 'Property damage documentation' },
      { t: 'Open / In-Progress / Closed case tracking' },
      { t: 'Subcontractor management' },
      { t: 'Live dashboard & metrics' },
      { t: 'Unlimited technicians' },
      { t: 'Single location' },
    ],
  },
  {
    name: 'Grow',
    price: '$199',
    period: '/ month',
    note: '$169/mo billed annually',
    blurb: 'For growing fleets that want the workflow running itself.',
    cta: 'Start with Grow',
    ctaHref: '/register',
    featured: true,
    features: [
      { t: 'Everything in Free' },
      { t: 'Multi-location branches' },
      { t: 'Automated client outreach & self-scheduling', soon: true },
      { t: 'Technician coaching portal', soon: true },
      { t: 'Digital liability release', soon: true },
      { t: 'Priority support' },
    ],
  },
  {
    name: 'Enterprise',
    price: '$499+',
    period: '/ month',
    note: 'Starting price — or custom quote',
    blurb: 'For large operations that need managed dispatch and integrations.',
    cta: 'Contact Sales',
    ctaHref: `mailto:${CONTACT_EMAIL}`,
    featured: false,
    features: [
      { t: 'Everything in Grow' },
      { t: '1-click emergency dispatching', soon: true },
      { t: 'Managed dispatch (TPA) escalation', soon: true },
      { t: 'Custom integrations' },
      { t: 'Dedicated onboarding & SLA' },
    ],
  },
]
